const TEAM_MEMBER_DOMAINS: string[] = ['unriddle.ai', 'anara.com', 'anara.so'];
const VISITOR_IDS: string[] = [
  '9069RVdobFjSwN5pNdW9',
  'VoLq7iRWqYCWvcLq9qw8',
  'qrqAfieu3sMceSIFJBr0',
  'aXwljcmTriRQeXHYLwTW',
  '0Q5b5ySi2fOzhtUminHn',
  'xHjfboMvRdNppBBYkKu8',
];

export function isAnaraTeamMember(
  email?: string | null,
  visitorId?: string | null,
): boolean {
  if (!email && !visitorId) return false;
  if (VISITOR_IDS.includes(visitorId ?? '')) {
    return true;
  }
  return TEAM_MEMBER_DOMAINS.some((domain) => email?.endsWith(`@${domain}`));
}
